import { useTranslation } from "react-i18next";
import WordsContainer from "../wordsContainer";
import parse from "html-react-parser";
import { useIsMobile } from "../../../utils/isMobile";

import "./styles.css";

function AboutSection() {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  return (
    <div className="lp-main-about">
      {isMobile ? (
        <>
          <div className="lp-main-about-we-made">
            <span>{t("landingPage.about.weMade.label")}</span>
            <WordsContainer />
          </div>
          <div className="lp-main-about-text-container">
            <div className="lp-main-about-text">{parse(t("landingPage.about.text"))}</div>
          </div>
        </>
      ) : (
        <>
          <div className="lp-main-about-text">{parse(t("landingPage.about.text"))}</div>
          <div className="lp-main-about-we-made">
            <span>{t("landingPage.about.weMade.label")}</span>
            <WordsContainer />
          </div>
        </>
      )}
    </div>
  );
}

export default AboutSection;
